.aside {
  padding: 1.5rem;
  width: 100%;
  height: 89vh; /* 100vh - topbar's height */
  display: grid;
  align-content: space-between;
  backdrop-filter: blur(7px);
  font-family: "Nunito Variable", sans-serif;
}

.routes a {
  display: block;
  margin-bottom: 1.7rem;
  font-size: var(--large-text);
  font-weight: 500;
}

.themeNavBtn {
  display: flex;
  align-items: center;
  padding-top: 20px;
  font-size: var(--large-text);
  width: 100%;
  border: none;
  background-color: transparent;
}

.themeNavBtnIcon {
  margin-right: 5px;
  display: flex;
}

.themeModal {
  padding: 5px;
  border-radius: 5px;
}

.themeOption {
  display: flex;
  align-items: center;
  padding: 5px 13px;
  border: none;
  border-radius: 3px;
  width: 100%;
  background-color: transparent;
  font-size: var(--large-text);
}

.themeOption span {
  margin-left: 9px;
}

/* Tablet */
@media (min-width: 768px) {
  .aside {
    padding: 2.5rem 3rem;
  }
  .routes a {
    margin-bottom: 3rem;
    font-size: var(--large-text);
  }
  .themeNavBtn {
    padding-top: 30px;
    font-size: var(--large-text);
  }
  .themeOption {
    padding: 30px;
    border-radius: 3px;
    font-size: var(--large-text);
  }
  .themeOption span {
    margin-left: 30px;
  }
}

/* Color scheme when device's theme is light mode */
@media (prefers-color-scheme: light) {
  .aside {
    background-color: rgba(255, 255, 255, 0.91);
  }
  .routes a,
  .themeNavBtn {
    color: var(--primary-color);
  }
  .themeModal {
    background-color: var(--secondary-color);
    box-shadow: rgba(14, 30, 37, 0.12) 0px 2px 4px 0px,
      rgba(14, 30, 37, 0.32) 0px 2px 16px 0px;
  }
  .themeNavBtnContainer {
    border-top: 1px solid var(--primary-color);
  }
}

/* Color scheme when device's theme is dark mode */
@media (prefers-color-scheme: dark) {
  .aside {
    background-color: rgba(17, 17, 17, 0.91);
  }
  .routes a {
    color: var(--secondary-color);
  }
  .themeModal {
    background-color: var(--primary-color);
    box-shadow: rgba(241, 225, 218, 0.12) 0px 2px 4px 0px,
      rgba(241, 225, 218, 0.32) 0px 2px 16px 0px;
  }
  .themeNavBtnContainer {
    border-top: 1px solid var(--secondary-color);
  }
  .themeNavBtn {
    color: var(--secondary-color);
  }
}
